import { Box, Grid, GridItem, Text } from "@chakra-ui/react";
import { useMemo } from "react";

import { ErrorResponse } from "@reflag/shared/api";

export function ErrorResponseDisplay({
  response,
}: {
  response?: ErrorResponse;
}) {
  const entries = useMemo(() => {
    if (!response?.issues) {
      return [];
    }

    return Object.entries(response.issues ?? {}).flatMap(([path, errors]) => {
      return errors.map((error) => ({
        path,
        message: error,
      }));
    });
  }, [response]);

  if (!response) {
    return null;
  }

  return (
    <Box>
      <Text>Error: {response.error.message ?? response.error.code}</Text>
      {entries.length > 0 && (
        <Grid as="dl" gap={2} gridTemplateColumns={"max-content 1fr"}>
          {entries.map((error, idx) => (
            <>
              <GridItem key={`${idx}_path`} as="dt">
                {error.path}
              </GridItem>
              <GridItem key={`${idx}_message`} as="dd">
                {error.message}
              </GridItem>
            </>
          ))}
        </Grid>
      )}
    </Box>
  );
}
